'use client';

import React, { useState, useEffect } from 'react';
import { useHostControl } from './HostControlContext';
import { useLocalParticipant } from '@livekit/components-react';
import { MicOff, VideoOff, AlertCircle } from 'lucide-react';

export function HostControlFeedback() {
  const { mutedParticipants, videoDisabledParticipants } = useHostControl();
  const localParticipant = useLocalParticipant();
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState<'mute' | 'video' | null>(null);

  const isMuted = mutedParticipants.has(localParticipant.localParticipant?.identity || '');
  const isVideoDisabled = videoDisabledParticipants.has(
    localParticipant.localParticipant?.identity || '',
  );

  useEffect(() => {
    if (isMuted && feedbackType !== 'mute') {
      setFeedbackMessage('Seu microfone foi mutado pelo Anfitrião');
      setFeedbackType('mute');
      setShowFeedback(true);

      // Hide feedback after 5 seconds
      setTimeout(() => {
        setShowFeedback(false);
        setFeedbackType(null);
      }, 5000);
    } else if (isVideoDisabled && feedbackType !== 'video') {
      setFeedbackMessage('Sua câmera foi desabilitada pelo Anfitrião');
      setFeedbackType('video');
      setShowFeedback(true);

      // Hide feedback after 5 seconds
      setTimeout(() => {
        setShowFeedback(false);
        setFeedbackType(null);
      }, 5000);
    } else if (!isMuted && feedbackType === 'mute') {
      // Participant unmuted themselves - hide feedback
      setShowFeedback(false);
      setFeedbackType(null);
    } else if (!isVideoDisabled && feedbackType === 'video') {
      // Participant enabled video themselves - hide feedback
      setShowFeedback(false);
      setFeedbackType(null);
    }
  }, [isMuted, isVideoDisabled, feedbackType]);

  if (!showFeedback) return null;

  return (
    <div className="fixed top-4 right-4 z-50 bg-red-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-sm">
      <AlertCircle className="w-5 h-5 flex-shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-medium">{feedbackMessage}</p>
        <div className="flex items-center gap-2 mt-1">
          {feedbackType === 'mute' && <MicOff className="w-4 h-4" />}
          {feedbackType === 'video' && <VideoOff className="w-4 h-4" />}
          <span className="text-xs opacity-90">
            {feedbackType === 'mute' ? 'Microfone mutado' : 'Câmera desabilitada'}
          </span>
        </div>
      </div>
      <button
        onClick={() => setShowFeedback(false)}
        className="text-white hover:text-gray-200 transition-colors"
      >
        ×
      </button>
    </div>
  );
}
